<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Suppose we have a
        <number-value :value="concInit" unit="\text{M}" />
        aqueous solution of trimethylamine,
        <chemical-latex content="(CH3)3N" />
        <stemble-latex content="$\text{(pK}_\text{b}=4.19).$" />
      </p>

      <p class="mb-2">
        a) Calculate the value of
        <stemble-latex content="$\text{K}_\text{b}$" />
        for the base.
      </p>

      <calculation-input
        v-model="inputs.Kb"
        class="mb-5"
        prepend-text="$\text{K}_\text{b}:$"
        :disabled="!allowEditing"
      />

      <p class="mb-2">
        b) What is the concentration of trimethylamine once the system reaches equilibrium?
      </p>

      <calculation-input
        v-model="inputs.concA"
        class="mb-5"
        prepend-text="$\ce{[(CH3)3N]}_\text{eq}:$"
        append-text="$\text{M}$"
        :disabled="!allowEditing"
      />

      <p class="mb-2">
        c) What is the concentration of the conjugate acid of trimethylamine at equilibrium?
      </p>

      <calculation-input
        v-model="inputs.concHA"
        class="mb-5"
        prepend-text="$\ce{[(CH3)3NH+]}_\text{eq}:$"
        append-text="$\text{M}$"
        :disabled="!allowEditing"
      />

      <p class="mb-2">d) What is the pOH of this solution?</p>

      <calculation-input
        v-model="inputs.pOH"
        class="mb-5"
        prepend-text="$\text{pOH:}$"
        :disabled="!allowEditing"
      />

      <p class="mb-2">e) What is the pH of the solution?</p>

      <calculation-input
        v-model="inputs.pH"
        class="mb-0"
        prepend-text="$\text{pH:}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import ChemicalLatex from '../displayers/ChemicalLatex';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalNotationInput from '@/chemical-equations/components/ChemicalNotationInput.vue';
import NumberValue from '@/tasks/components/NumberValue.vue';

export default {
  name: 'Question465',
  components: {
    NumberValue,
    ChemicalNotationInput,
    CalculationInput,
    ChemicalLatex,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        Kb: null,
        concA: null,
        concHA: null,
        pOH: null,
        pH: null,
      },
    };
  },
  computed: {
    concInit() {
      return this.taskState.getValueBySymbol('concInit').content;
    },
  },
};
</script>
